import { render } from "./Presentation.vue?vue&type=template&id=5b6d7d47&scoped=true"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import "./Presentation.vue?vue&type=style&index=0&id=5b6d7d47&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6d7d47"]])

export default __exports__